<dashboard-grid [setup]="partService.gridSetup()" [size]="{}" [rows]="partService.rows()"
	(selectedRows)="partService.setSelectedRows($event)"></dashboard-grid>